module.exports = __webpack_public_path__ + "static/annie-spratt-pbrQvuKJQf8-unsplash-e6fe6f4ae40f46ed0977ad26bac9e9f1.png";